var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCat13(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.205,
    height: 34.922,
    viewBox: "0 0 32.205 34.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_87747",
    "data-name": "Path 87747",
    d: "M49.968,32.876V7.78h-3.25v25.1H44.672V0L27.353,4.856v6.956h7.4V32.876H32.7V13.858h-8.6V32.876h-4.2v2.047H52.118V32.876ZM38.643,21.208V17.091H40.69v4.117Zm2.047,3.4v4.117H38.643V24.61ZM38.643,13.689V9.572H40.69v4.117Zm-11.26,3.4H29.43v4.117H27.383Zm0,7.519H29.43v4.117H27.383Z",
    transform: "translate(-19.912)",
    fill: "#85899c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat13);
export default __webpack_public_path__ + "static/media/cat_13.6c392b833435c4bcc5d8101860eeec61.svg";
export { ForwardRef as ReactComponent };